import React from "react";

const MinusIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="32" height="32" rx="16" fill="#EAF8F4" />
			<path
				d="M16.9525 16.9516H21.7144C22.2383 16.9516 22.6668 16.5231 22.6668 15.9993C22.6668 15.4754 22.2383 15.0469 21.7144 15.0469H16.9525L16.0002 15.047L15.0478 15.0469H10.2859C9.76207 15.0469 9.3335 15.4754 9.3335 15.9993C9.3335 16.5231 9.76207 16.9516 10.2859 16.9516H15.0478H16.0002H16.9525Z"
				fill="#1F8268"
			/>
		</svg>
	);
};

export default MinusIcon;
